import type { NDateLocale } from './enUS'
import { sv } from 'date-fns/locale'

const dateSvSE: NDateLocale = {
  name: 'sv-SE',
  locale: sv
}

export default dateSvSE
